function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useRef, useEffect, useState } from 'react';
import cn from 'classnames';
import { arrayOf, bool, string, shape } from 'prop-types';
import Image from '../../atoms/Image';
import List from '../List';
import MenuLink from '../../atoms/MenuLink';
import BackgroundImage from '../../atoms/BackgroundImage';
import PopupToggleButton from '../PopupToggleButton';
import AccountNav from '../AccountNav';
import PopupContext from '../../context/PopupContext';
import { debounce } from '../../utils';
import { useDesignTokens } from '../../hooks';
/**
 * Eyebrow component.
 */

var EyebrowNav = function EyebrowNav(_ref) {
  var className = _ref.className,
      items = _ref.items,
      logo = _ref.logo,
      logoUrl = _ref.logoUrl,
      swapContent = _ref.swapContent,
      accountNavOptions = _ref.accountNavOptions,
      avatarImage = _ref.avatarImage,
      mobileBackgroundImage = _ref.mobileBackgroundImage;

  var _useContext = useContext(PopupContext),
      activePopup = _useContext.activePopup,
      popupKeys = _useContext.popupKeys;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showBackgroundImage = _useState2[0],
      setShowBackgroundImage = _useState2[1];

  var containerRef = useRef(null);

  var _useDesignTokens = useDesignTokens(),
      grid = _useDesignTokens.grid;

  var handleResize = debounce(function () {
    // Detect if window size is less than or equal to our desktop breakpoint
    setShowBackgroundImage(window.innerWidth <= (grid === null || grid === void 0 ? void 0 : grid.lg));
  }, 100); // Check if the image is show on first render

  useEffect(function () {
    var offsetWidth = containerRef.current.offsetWidth;
    setShowBackgroundImage(offsetWidth <= (grid === null || grid === void 0 ? void 0 : grid.lg));
  }, []); // Watch for resizing of the viewport to show or hide the image

  useEffect(function () {
    window.addEventListener('resize', handleResize); // Clean up

    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [containerRef]);

  if (avatarImage) {
    avatarImage.sizes = ['28px'];
    avatarImage.srcSetBreakpoints = [28, 56, 84];
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cn(className, 'eyebrow-nav'),
    ref: containerRef
  }, /*#__PURE__*/React.createElement(BackgroundImage, {
    image: showBackgroundImage ? mobileBackgroundImage : null
  }, /*#__PURE__*/React.createElement("div", {
    className: "eyebrow-nav__container container container--no-gutters"
  }, popupKeys.mainNav && /*#__PURE__*/React.createElement("div", {
    className: 'eyebrow-nav__icon eyebrow-nav__icon--muted mr-xs' + (activePopup === popupKeys.mainNav ? " eyebrow-nav__icon--open" : "")
  }, /*#__PURE__*/React.createElement(PopupToggleButton, {
    popup: popupKeys.mainNav,
    openIcon: "menu",
    closeIcon: "menu-close"
  })), logo && /*#__PURE__*/React.createElement(Image, _extends({
    className: "eyebrow-nav__logo eyebrow-nav__brand-logo",
    maxHeight: 24,
    maxWidth: 120,
    fluid: true
  }, logo, {
    sizes: ['120px'],
    srcSetBreakpoints: [120, 240, 360, 480 // Up to 4x the max width for more pixel dense devices
    ],
    link: {
      href: logoUrl,
      rel: 'home'
    },
    loading: "eager"
  })), /*#__PURE__*/React.createElement("div", {
    className: "eyebrow-nav__desktop"
  }, swapContent && /*#__PURE__*/React.createElement("div", {
    className: "mt-xxs mb-xxs"
  }, /*#__PURE__*/React.createElement(Image, _extends({
    className: "eyebrow-nav__logo",
    maxHeight: 25,
    maxWidth: 120,
    fluid: true
  }, logo, {
    srcSetBreakpoints: [120, 240, 360, 480],
    sizes: ['120px'],
    link: {
      href: logoUrl,
      rel: 'home'
    },
    loading: "eager"
  }))), !swapContent && items.length > 0 && /*#__PURE__*/React.createElement("nav", {
    className: "eyebrow-nav__navigation",
    "aria-label": "Quick links",
    "data-feature": "QuickLinks"
  }, /*#__PURE__*/React.createElement(List, {
    horizontal: true
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(List.Item, {
      key: "".concat(item.label, "-").concat(item.relativeUrl || item.absoluteUrl),
      className: "eyebrow-nav__navigation-listitem body-copy-small",
      "data-index": index + 1,
      "data-component": "MenuLink",
      "data-item-name": item.label
    }, /*#__PURE__*/React.createElement(MenuLink, _extends({
      className: "eyebrow-nav__navigation-link"
    }, Object.assign(item, {
      children: null
    })), item.label));
  })))), accountNavOptions && /*#__PURE__*/React.createElement("div", {
    className: "eyebrow-nav__sign-in hidden-for-md-down"
  }, /*#__PURE__*/React.createElement(AccountNav, _extends({}, accountNavOptions, {
    avatarImage: avatarImage
  }))), /*#__PURE__*/React.createElement("div", {
    className: "eyebrow-nav__items-right ml-xs"
  }, popupKeys.account && accountNavOptions && /*#__PURE__*/React.createElement("div", {
    className: "eyebrow-nav__icon eyebrow-nav__account-icon" + (activePopup === popupKeys.account ? " eyebrow-nav__icon--open" : "")
  }, /*#__PURE__*/React.createElement(PopupToggleButton, {
    popup: popupKeys.account,
    openIcon: "profile",
    closeIcon: "cross"
  })), popupKeys.search && /*#__PURE__*/React.createElement("div", {
    className: "eyebrow-nav__icon eyebrow-nav__search-icon" + (activePopup === popupKeys.search ? " eyebrow-nav__icon--open" : "")
  }, /*#__PURE__*/React.createElement(PopupToggleButton, {
    popup: popupKeys.search,
    openIcon: "search",
    closeIcon: "cross"
  }))))));
};

EyebrowNav.defaultProps = {
  className: null,
  logo: null,
  items: [],
  swapContent: false,
  logoUrl: '/',
  accountNavOptions: null,
  avatarImage: null,
  mobileBackgroundImage: null
};
EyebrowNav.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The brand logo */
  logo: shape(Image.propTypes),

  /** Array of navigation items */
  items: arrayOf(shape(MenuLink.propTypes)),

  /** Set via parent element and is when the nav is stuck to top of page */
  swapContent: bool,

  /** The URL to link to from the logo. */
  logoUrl: string,

  /** Account Navigation options */
  accountNavOptions: shape(AccountNav.propTypes),

  /** Avatar image props */
  avatarImage: shape(AccountNav.propTypes.Image),

  /** Optional background image which appears on mobile only */
  mobileBackgroundImage: string
} : {};
export default EyebrowNav;